// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import propTypes from 'prop-types';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import { GatedConsentCategoriesSelect } from 'app/components/consent-categories-select/GatedConsentCategoriesSelect';
import FeatureGate from 'app/launch-darkly/gates/feature-gate';

import buildConsentCategorySelectProps from './buildConsentCategorySelectProps';
import { MrFormLabel } from '@ion/components';

export default function ConsentCategorySelect({ formState, setField, ...props }) {
  const consentCategorySelectProps = buildConsentCategorySelectProps({ formState, setField, ...props });

  return (
    <FeatureGate flagName={FEATURE_FLAGS.configurableConsentMvp}>
      <div className="content">
        <MrFormLabel label="Select Consent Category" />
        <GatedConsentCategoriesSelect {...consentCategorySelectProps} />
      </div>
    </FeatureGate>
  );
}

ConsentCategorySelect.propTypes = {
  formState: propTypes.object.isRequired,
  setField: propTypes.func.isRequired,
};
